// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-b1193f78] .attachment-uploader .form-control {\n  display: block;\n  width: 100%;\n}\n[data-v-b1193f78] .attachment-uploader.input-group {\n  margin-top: 0 !important;\n}\n.feedback textarea.form-control.randomized[data-v-b1193f78] {\n  width: 93% !important;\n}\n", ""]);
// Exports
module.exports = exports;
